import { render, staticRenderFns } from "./guahao.vue?vue&type=template&id=48c06822&scoped=true&"
import script from "./guahao.vue?vue&type=script&lang=js&"
export * from "./guahao.vue?vue&type=script&lang=js&"
import style0 from "./guahao.vue?vue&type=style&index=0&id=48c06822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c06822",
  null
  
)

export default component.exports